import {p} from './BasicAPI';

export function addSubscriptionEmail(email)
{
    return p('/subscription_email/add', {
        email
    });
}
